module.exports = __webpack_public_path__ + "img/mobile-verification-code.73ab63fb.png";